export const environment = {
  production: true,
  apiUrl: 'https://cmswebprdmtbr.azurewebsites.net/Api/',
  apiAppUrl: 'https://mobapiprdmt.azurewebsites.net/Api/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts